import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";
import "../date.js";
import { German as LocaleDE } from "flatpickr/dist/l10n/de.js"
import { French as LocaleFR } from "flatpickr/dist/l10n/fr.js"
import { Italian as LocaleIT } from "flatpickr/dist/l10n/it.js"
import { english as LocaleEN } from "flatpickr/dist/l10n/default.js"

// Connects to data-controller="invoices"
export default class extends Controller {
  connect() {
    let localeToUse = LocaleEN;
    
        if (document.body.attributes["locale"].value == "de") {
          localeToUse = LocaleDE
        }
        else if (document.body.attributes["locale"].value == "fr") {
          localeToUse = LocaleFR
        }
        else if (document.body.attributes["locale"].value == "it") {
          localeToUse = LocaleIT
        }

    flatpickr("#patientBirthdayWrapper", {dateFormat: "d.m.Y", weekNumbers: "true", wrap: true,locale: localeToUse});
  }
}
